/**
 * Words the super admin screens use (STE-1013).
 */

/**
 * Through Auth0 nobody is shown a password: Auth0 emails the person a link to
 * set their own, and the screen says so.
 */
export const emailedNotice = (email: string) => `We have emailed ${email} a link to set their password.`

/*
 * Company single sign-on (STE-1022). The person logs in with their own
 * company's login, so there is no password and nothing was emailed.
 */
export const ssoNotice = (email: string) =>
  `${email} logs in with their company single sign-on. We have not sent them an email.`

/** Shown in place of a sign-in state, for somebody at a single sign-on company. */
export const SSO_PERSON = 'Logs in with company single sign-on'

/* ---------- setting a password directly (STE-1044) ---------- */

export const SET_PASSWORD = 'Set password'

/**
 * Offered only where people log in through Auth0, and only for somebody who
 * has a password login: not single sign-on, and not a person with no login.
 */
export const canSetPassword = (available: boolean | undefined, person: { sso?: boolean; noLogin?: boolean }) =>
  Boolean(available) && !person.sso && !person.noLogin

/** What stops the two typed passwords being sent, or null when nothing does. */
export function passwordProblem(first: string, second: string): string | null {
  if (!first) return 'Type the new password.'
  if (!second) return 'Type it again to check it.'
  if (first !== second) return 'The two passwords do not match.'
  return null
}

export const passwordSetNotice = (name: string) =>
  `${name}'s new password is set, and they have been signed out everywhere. We have not sent them an email.`
